// Inspired by https://github.com/kuuurt13/ng-block-ui/blob/master/lib/directives/block-ui.directive.ts
import { ComponentRef, Directive, effect, inject, input, OnInit, TemplateRef, untracked, ViewContainerRef } from '@angular/core';

import { BaasLoading } from './baas-loading';
import { BaasLoadingOptions } from './baas-loading-options.type';

@Directive({ selector: '[baasLoading]' })
export class BaasLoadingBehavior implements OnInit {
    readonly #templateRef = inject<TemplateRef<any>>(TemplateRef);
    readonly #viewRef = inject(ViewContainerRef);

    readonly baasLoading = input<boolean>();
    readonly baasLoadingOptions = input<BaasLoadingOptions>();

    // holds reference to the bar loading component
    #componentRef: ComponentRef<BaasLoading>;

    constructor() {
        effect(() => {
            const barLoading = this.baasLoading();
            untracked(() => {
                if (this.#componentRef != null) {
                    this.#componentRef.instance.running.set(barLoading);
                }
            });
        });
        effect(() => {
            const options = this.baasLoadingOptions();
            untracked(() => {
                if (this.#componentRef != null) {
                    this.#componentRef.instance.options.set(options);
                }
            });
        });
    }

    ngOnInit(): void {
        this.#viewRef.createEmbeddedView(this.#templateRef);
        // get the real element on which directive is applied
        const parentElement = this.#viewRef.element.nativeElement.previousSibling;
        parentElement.style.position = 'relative';
        // create the bar loading component
        this.#componentRef = this.#viewRef.createComponent(BaasLoading);
        this.#componentRef.instance.running.set(this.baasLoading());
        this.#componentRef.instance.options.set(this.baasLoadingOptions());
        // put it into the component on which the directive is applied
        parentElement.appendChild(parentElement.nextSibling);
        // tell the component it is being invoked from the directive
        this.#componentRef.instance.fromDirective.set(true);
    }
}
